import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteTipoDeDepositoBancario,
  getTiposDeDepositosBancarios,
  patchTipoDeDepositoBancario,
  postTipoDeDepositoBancario,
} from 'api/configuracion/tiposDeDepositoBancario';

// eslint-disable-next-line react/prop-types
const TiposDeDepositosBancarios = ({ permission }) => (
  <PlainCRUD
    title="Tipo de Depósito"
    permission={permission}
    get={getTiposDeDepositosBancarios}
    post={postTipoDeDepositoBancario}
    patch={patchTipoDeDepositoBancario}
    delete={deleteTipoDeDepositoBancario}
    withoutState
    fields={[
      defaultFields.clave,
      defaultFields.descripcion,
    ]}
  />
);

export default TiposDeDepositosBancarios;
